export const STORAGE = 'storage';
export const TOKEN = 'token';
export const REFRESH_TOKEN = 'refreshToken';
export const PERSIST_KEY = 'persist:root';
